import templateUrl from './productImage.html'
import noImage from 'tmrAssets/images/no-image.jpg'

/**
 * Product Image component.
 *
 * Show the product's image if present on server, a "no image" otherwise
 *
 * @example
 *   <tmr-product-image
 *     product="$ctrl.product"
 *   ></tmr-product-image>
 *
 * @type {ngComponent}
 * @prop {TmrResource} product
 */
export const tmrProductImage = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrProductImageController',
  bindings: {
    product: '<',
  },
}

/**
 * Controller of component {@link tmrProductImage}.
 *
 * @type {ngController}
 */
export class tmrProductImageController {
  static ngType = 'controller'

  $onInit() {
    this.noImage = noImage
  }
}
